import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Menu, Dropdown, Icon, Modal } from 'antd';
import './ComponentWrapper.css';
import { ImportModule, ImportForm } from './DynamicImporter';

const ComponentWrapper = props => {
    const [compName] = useState(props.compName);
    const [compProps, setCompProps] = useState(props.compProps);
    const [dynamicClass, setDynamicClass] = useState('');
    const [modalVisible, setModalVisible] = useState(false);

    const newComp = <ImportModule name={compName} props={compProps} />;

    useEffect(() => {
        if (props.compProps === null) {
            onEditClicked();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onEditClicked = () => {
        onContextMenuToggled(false);

        setModalVisible(true);
    };

    const onRemoveClicked = () => {
        let { onRemove, id } = props;

        onRemove && onRemove(id);
        onContextMenuToggled(false);
    };

    const onContextMenuToggled = visible => {
        if (visible) {
            setDynamicClass('compWrapper--active');
        } else {
            setDynamicClass('');
        }
    };

    const onMoveUpClicked = () => {
        let { onMoveUpClicked, id } = props;

        onMoveUpClicked && onMoveUpClicked(id);
        onContextMenuToggled(false);
    };

    const onMoveDownClicked = () => {
        let { onMoveDownClicked, id } = props;

        onMoveDownClicked && onMoveDownClicked(id);
        onContextMenuToggled(false);
    };

    const onEditFormOk = values => {
        let { updateProps, id } = props;

        setCompProps(values);
        setModalVisible(false);

        updateProps && updateProps(id, values);
    };

    const onEditFormCancel = e => {
        setModalVisible(false);
    };

    const form = <ImportForm name={compName} props={compProps} onOk={onEditFormOk} onCancel={onEditFormCancel} />;

    return (
        <React.Fragment>
            <Dropdown
                trigger={['contextMenu']}
                onVisibleChange={onContextMenuToggled}
                overlay={
                    <Menu>
                        <Menu.Item key="1" onClick={onEditClicked}>
                            <Icon type="edit" />
                            Edit
                        </Menu.Item>
                        <Menu.Item key="2" onClick={onMoveUpClicked}>
                            <Icon type="arrow-up" />
                            Move up
                        </Menu.Item>
                        <Menu.Item key="3" onClick={onMoveDownClicked}>
                            <Icon type="arrow-down" />
                            Move down
                        </Menu.Item>
                        <Menu.Item key="4" onClick={onRemoveClicked}>
                            <Icon type="delete" />
                            Remove
                        </Menu.Item>
                    </Menu>
                }>
                <div className={'compWrapper ' + dynamicClass} onDoubleClick={onEditClicked}>
                    {newComp}
                </div>
            </Dropdown>
            <Modal title={compName} visible={modalVisible} onCancel={onEditFormCancel} footer={null}>
                {form}
            </Modal>
        </React.Fragment>
    );
};

const mapStateToProps = state => ({
    i18n: state.i18n
});

export default connect(
    mapStateToProps,
    null
)(ComponentWrapper);
